export const formFields = [
  {
    label: 'Process',
    key: 'process',
    isRequired: true,
  },
  {
    label: 'Replacement Time',
    key: 'replacementTime',
    type: 'time',
    decoratorWord: 'months',
    isRequired: true,
  },
  {
    label: 'Replacement Cost (If known)',
    key: 'replacementCost',
    type: 'money',
    isRequired: true,
  },
];
